import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {
  private SUBDOMAIN_KEY = "subDomain";

  private protocol: string = environment.protocol;
  private subDomain: string = "";
  private baseDomain: string = environment.baseDomain;
  constructor(private http: HttpClient) {
    this.loadSubDomain();
  }

  setSubDomain(subDomain: string) {
    this.subDomain = subDomain;
    window.localStorage.setItem(this.SUBDOMAIN_KEY, subDomain);
  }

  loadSubDomain() {
    if (!this.subDomain || this.subDomain == "") {
      const subDomainStorage = window.localStorage.getItem(this.SUBDOMAIN_KEY);
      if (subDomainStorage) {
        this.subDomain = subDomainStorage;
      }
    }
  }

  getSubDominio(): string {
    return this.subDomain;
  }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get<T>(path: string, params: HttpParams = new HttpParams(), subDomain = ""): Observable<T> {
    return this.http.get<T>(`${this.getUrl(subDomain)}${path}`, { params }).pipe(
      catchError(this.formatErrors)
    );
  }

  getFile(path: string, params = {}): Observable<any> {
    return this.http.get(`${this.baseDomain}${path}`, { responseType: 'blob', params }).pipe(
      catchError(this.formatErrors)
    );
  }

  post<T>(path: string, params: URLSearchParams, subDomain: string = ""): Observable<T> {
    return this.http.post<T>(`${this.getUrl(subDomain)}${path}`, params.toString(), {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
    }).pipe(
      catchError(this.formatErrors));
  }

  postEndpoint<T>(endpoint: string, params: URLSearchParams): Observable<T> {
    return this.http.post<T>(endpoint, params.toString(), {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
    }).pipe(
      catchError(this.formatErrors));
  }

  put<T>(path: string, body: Object = {}): Observable<T> {
    return this.http.put<T>(`${this.baseDomain}${path}`, JSON.stringify(body)).pipe(
      catchError(this.formatErrors)
    );
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(`${this.baseDomain}${path}`).pipe(catchError(this.formatErrors));
  }

  getUrl(subDomain: string): string {
    if (subDomain && subDomain !== "") {
      return `${this.protocol}://${subDomain}.${this.baseDomain}`;
    } else if (this.subDomain && this.subDomain !== ""){
      return `${this.protocol}://${this.subDomain}.${this.baseDomain}`;
    } else {
      return "";
    }
  }
}
